export enum EnrollmentStatus {
  Open  , Approved  , Declined
}
